import api from '../api';

export async function getAllows() {
  return api.get('product_price_table/allows');
}
  
export async function getPriceTables(description, numOfRegisters = 10, page = 1, order) {
  const params = {
    order: order ? order : 'description',
  }
  if (description) {
    params.description = description.trim(); 
  }

  return api.get('product_price_table', {
    params,
    headers: {
      registerperpage: numOfRegisters,
      page
    }
  });
}

export async function getPriceTable(id) {
  return api.get(`product_price_table/${id}`);
}

export async function postPriceTable(data) {
  return api.post(`product_price_table/`, data);
}

export async function putPriceTable(id, data) {
  return api.put(`product_price_table/${id}`, data);
}

export async function deletePriceTable(id) {
  return api.delete(`product_price_table/${id}`);
}

export async function findPriceTable(description, numOfRegisters = 10) {
  return api.get('product_price_table', {
    params: {
      description,
      order: 'description'
    },
    headers: {
      registerperpage: numOfRegisters,
      page: 1
    }
  });
}
